import { gql } from "@apollo/client";

export const MARCAR_NOTIFICACION_LEIDA = gql`
  mutation ($notificacionId: ID!) {
    notificaciones {
      marcarNotificacionLeida(notificacionId: $notificacionId)
    }
  }
`;

export const ELIMINAR_NOTIFICACION = gql`
  mutation ($notificacionId: ID!) {
    notificaciones {
      eliminarNotificacion(notificacionId: $notificacionId)
    }
  }
`;